export const errorCodeToMessage = {
  'auth/email-already-in-use': 'The Email address already in use',
  'auth/invalid-email': 'The Email address is incorrect',
  'auth/wrong-password': 'The password is incorrect',
};
